export const NAVIGATE = "navigate";
export const INITIALIZE = "initialize";
export const LOGIN = "login";
export const VALID_INCOMING_EVENTS = [NAVIGATE, INITIALIZE, LOGIN];
